let cities = require('./cities');
let rubrics = require('./rubrics');
let addParams = require('./additional-parameters');
let tooltip = require('./tooltip/');
const MakeOrderButton = require('../../order/header/make-order-button');
let css = require('./custom-order.css');
let { cut } = require('../../../helpers/utils');

const RESET_SELECTOR = cut(css.reset);

class CustomOrder {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        let isEditable = this.$context.props.isEditable;
        let showReset = this.$context.props.showReset;
        let showOrderButton = this.$context.props.showOrderButton;
        return this.$context.getWatcherData()
            .then((data) => Object.assign({ isEditable, showReset, showOrderButton }, data, { css }));
    }

    bind () {
        return {
            click: {
                [RESET_SELECTOR]: this.onReset
            }
        };
    }

    onReset (e) {
        e.preventDefault();
        this.$context.signal(this.$context.props.onReset);
    }
}

module.exports = {
    constructor: CustomOrder,
    children: [
        {
            name: 'cities-collapse',
            component: cities,
            parentPropsMap: {
                isSmallTree: 'isSmallTree',
                dontUseMetric: 'dontUseMetric'
            },
            props: {
                metricCategory: 'link_city'
            }
        },
        {
            name: 'rubrics-collapse',
            component: rubrics,
            parentPropsMap: {
                isSmallTree: 'isSmallTree',
                dontUseMetric: 'dontUseMetric'
            },
            props: {
                metricCategory: 'link_rubric'
            }
        },
        {
            name: 'additional-parameters-collapse',
            component: addParams,
            parentPropsMap: {
                isSmallTree: 'isSmallTree',
                dontUseMetric: 'dontUseMetric'
            },
            props: {
                metricCategory: 'link_extra_options'
            }
        },
        {
            name: 'tooltip',
            component: tooltip,
            watcher: {
                showDataChangedTooltip: ['order', 'computed', 'showDataChangeTooltip']
            }
        },
        {
            name: 'make-order-button',
            component: MakeOrderButton,
            props: {
                isBig: true
            },
            watcher: {
                totalPrice: ['order', 'price', 'data', 'total', 'totalPrice'],
                isZero: ['order', 'price', 'isZero']
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/common/custom-order/index.js